import React from 'react';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { RouteObject } from '@leagueplatform/routing';
import {
  APP_MANAGED_ROUTES,
  SUPPORT_SUB_ROUTES,
} from 'common/app-managed-routes';
import { BasePathRedirect } from 'components/base-path-redirect/base-path-redirect.component';
import { DuplicatePathRedirect } from 'components/duplicate-path-redirect/duplicate-path-redirect.component';
import { SupportSubPathRedirect } from 'components/support-subpath-redirect/support-subpath-redirect.component';
import { CareManagementFlowRedirect } from 'components/care-management-flow-redirect/care-management-flow-redirect';

const supportSubRoutesPaths = [
  `${SUPPORT_SUB_ROUTES.FORMS_LIBRARY}/*`,
  `${SUPPORT_SUB_ROUTES.LIVE_CHAT}/*`,
  `${SUPPORT_SUB_ROUTES.MESSAGING}/*`,
];

export const RedirectRoutes: RouteObject[] = [
  { path: '', element: <DuplicatePathRedirect /> },
  {
    path: APP_MANAGED_ROUTES.CARE_REDIRECT,
    element: (
      <BasePathRedirect targetBasePath={LEAGUE_MODULE_NAMES.careDiscovery} />
    ),
  },
  {
    path: `${APP_MANAGED_ROUTES.WALLET_REDIRECT}/*`,
    element: (
      <BasePathRedirect
        targetBasePath={getModulePath(LEAGUE_MODULE_NAMES.benefits)}
      />
    ),
  },
  {
    path: `${APP_MANAGED_ROUTES.MEMBER_REDIRECT}/*`,
    element: <BasePathRedirect targetBasePath="" />,
  },
  {
    path: APP_MANAGED_ROUTES.CASE_MANAGEMENT_TOOLBOX_LEGACY,
    element: <CareManagementFlowRedirect />,
  },
  ...supportSubRoutesPaths.map((path) => ({
    path,
    element: <SupportSubPathRedirect />,
  })),
];
